import { Link } from '@tanstack/react-router';
import { Mail } from 'lucide-react';
import { communityTrpc } from '@org/clients/community';
import { Button } from '@org/ui';
import { useTranslation } from 'react-i18next';

export function MessagesBadge() {
  const { t } = useTranslation('community');
  const { data } = communityTrpc.messages.getUnreadCount.useQuery(undefined, {
    refetchInterval: 10_000,
  });

  const count = data?.count ?? 0;

  return (
    <Link to="/messages">
      <Button
        variant="ghost"
        size="icon"
        className="relative"
        aria-label={t('messages.title')}
      >
        <Mail className="h-5 w-5" />
        {count > 0 && (
          <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-medium text-white">
            {count > 99 ? '99+' : count}
          </span>
        )}
      </Button>
    </Link>
  );
}
